import { getEnv, isDebug } from '~/src/dash/resellers/utils/importResellerConfig';

// Log warning only if not prod
export function warn(...args: any) {
  if (getEnv() !== 'prod' || isDebug()) {
    // lint:disable-next-line
    console.warn(...args);
  }
}

// Log error only if not prod
export function error(...args: any) {
  if (getEnv() !== 'prod' || isDebug()) {
    // lint:disable-next-line
    console.error(...args);
  }
}
